import { DrawerBody, DrawerHeader } from '@/components/Drawer';
import { MetaAddonsType } from '@/hooks/useAddonsMeta';
import { EnabledAddonsType } from '@/hooks/useListEnabledAddons';
import { DrawerHeadContainer } from '@/lib/styled';
import { cn } from '@/lib/utils';
import { CustomizeWorkspace } from '@/pages/home/icons';
import { drawerConfigComponentMap } from '@/pages/workgroup/form/addons/edit-drawer/config';
import { WorkspaceT } from '@/pages/workgroup/type';
import { useStyletron } from '@tigergraph/app-ui-lib/Theme';
import clsx from 'clsx';
import { FC } from 'react';
import { UseFormReturn } from 'react-hook-form';

const EditWorkspaceAddons: FC<{
  form: UseFormReturn;
  isOpen?: boolean;
  workspace: WorkspaceT;
  selectedAddonsMeta?: MetaAddonsType;
  selectedEnabledAddons?: EnabledAddonsType;
}> = ({ form, isOpen, workspace, selectedAddonsMeta, selectedEnabledAddons }) => {
  const Component = drawerConfigComponentMap.get(selectedAddonsMeta?.ID || '');
  const [css, theme] = useStyletron();

  if (!Component) {
    return null;
  }

  return (
    <div
      className={cn(
        clsx(
          isOpen && '-translate-x-full',
          'h-full absolute left-0 top-0 -z-10 border-r transition duration-200 ease-out'
        ),
        css({
          borderColor: theme.colors['border.tertiary'],
          backgroundColor: theme.colors['background.primary'],
        })
      )}
    >
      <DrawerHeader>
        <DrawerHeadContainer>
          {selectedAddonsMeta?.WorkspaceAvatar ? (
            <img className="w-8" src={selectedAddonsMeta.WorkspaceAvatar} />
          ) : (
            <CustomizeWorkspace />
          )}
          Configure {selectedAddonsMeta?.Title}
        </DrawerHeadContainer>
      </DrawerHeader>
      <DrawerBody>
        <Component
          form={form}
          workspace={workspace}
          selectedAddonsMeta={selectedAddonsMeta}
          selectedEnabledAddons={selectedEnabledAddons}
        />
      </DrawerBody>
    </div>
  );
};

export default EditWorkspaceAddons;
